export default {
  pbrTopicProject: [
    {
      id: '28173306385399808',
      title: '中国能建签署乌克兰Karsa垃圾电站项目EPC合同',
      time: '2021-08-19'
    },
    {
      id: '26307676061302784',
      title: '中油工程中标尼日尔油田发电站项目',
      time: '2021-08-19'
    },
    {
      id: '26307675549597696',
      title: '中东分公司成功签约沙特吉赞市道路及公共基础设施建设项目',
      time: '2021-08-19'
    },
    {
      id: '26307671430791168',
      title: '山东一建印尼韦达贝项目1号机组并网发电',
      time: '2021-08-19'
    },
    {
      id: '26307672873631744',
      title: '中油工程伊拉克巴士拉天然气处理厂1.7亿美元施工总承包开工！',
      time: '2021-08-19'
    },
    {
      id: '26307676061302784',
      title: '中油工程中标尼日尔油田发电站项目',
      time: '2021-08-19'
    },
    {
      id: '26307675549597696',
      title: '中东分公司成功签约沙特吉赞市道路及公共基础设施建设项目',
      time: '2021-08-19'
    },
    {
      id: '26307671430791168',
      title: '山东一建印尼韦达贝项目1号机组并网发电',
      time: '2021-08-19'
    },
    {
      id: '26307672873631744',
      title: '中油工程伊拉克巴士拉天然气处理厂1.7亿美元施工总承包开工！',
      time: '2021-08-19'
    }
  ],
  pbrTopicInfo: [
    {
      id: '28173306385399808',
      title: '印度尼西亚Pelangai河P2水电站(11MW)项目（EPC）',
      time: '2021-08-24'
    },
    {
      id: '28173323984699392',
      title: '奥地利房地产项目投资',
      time: '2021-08-24'
    },
    {
      id: '28173507691020288',
      title: '罗马尼亚克鲁日省杰卡市3兆瓦光伏电站项目',
      time: '2021-08-24'
    },
    {
      id: '28178782917492736',
      title: '关于继续加强疫情防范的提醒',
      time: '2021-08-24'
    },
    {
      id: '28178789607407616',
      title: '关于在喀中国企业和公民提高安全意识的提醒',
      time: '2021-08-24'
    },
    {
      id: '28178792895741952',
      title: '再次温馨提醒在马中国同胞注意防疫安全',
      time: '2021-08-24'
    },
    {
      id: '28178786629451776',
      title: '亚丁湾发生5.5级地震，震源深度10千米',
      time: '2021-08-24'
    },
    {
      id: '28173515467259904',
      title: '肯尼亚输变电项目LOT2（EPC）',
      time: '2021-08-24'
    },
    {
      id: '28173456805724160',
      title:
        '乌方希望中国企业投资建设的汽车零部件生产厂、皮革加工厂、水泥厂、玻璃厂、洁具陶瓷厂、果蔬加工厂项目',
      time: '2021-08-24'
    }
  ],
  regionDistChartData: [
    {
      id: 1,
      name: '东亚',
      percentage: '39%'
    },
    {
      id: 2,
      name: '欧洲',
      percentage: '7%'
    },
    {
      id: 3,
      name: '西亚',
      percentage: '16%'
    },
    {
      id: 4,
      name: '中东',
      percentage: '14%'
    },
    {
      id: 5,
      name: '南美',
      percentage: '36%'
    }
  ],
  industryDistChatData: [
    {
      id: '25634563304718336',
      industry: '能源矿产',
      num: 53,
      percent: '5.3%'
    },
    {
      id: '25634562709127168',
      industry: '电力',
      num: 597,
      percent: '59.7%'
    },
    {
      id: '25634566303645696',
      industry: '交通运输',
      num: 292,
      percent: '29.2%'
    },
    {
      id: '25634564823056384',
      industry: '轻纺食品',
      num: 14,
      percent: '1.4%'
    },
    {
      id: '25634569029943296',
      industry: '材料',
      num: 24,
      percent: '2.4%'
    },
    {
      id: '25634566932791296',
      industry: '机械电子',
      num: 1,
      percent: '0.1%'
    },
    {
      id: '25634564323934208',
      industry: '化工医药',
      num: 5,
      percent: '0.5%'
    },
    {
      id: '25634567461273600',
      industry: '建筑',
      num: 14,
      percent: '1.4%'
    }
  ],
  hotWordDistChartData: [
    {
      'name': '燃煤电站',
      'value': 17
    },
    {
      'name': '中国电建',
      'value': 15
    },
    {
      'name': '光伏电站',
      'value': 12
    },
    {
      'name': '西电集团',
      'value': 11
    },
    {
      'name': '微电网光伏',
      'value': 10
    },
    {
      'name': '中国西电',
      'value': 10
    },
    {
      'name': '防控',
      'value': 10
    },
    {
      'name': '疫情防',
      'value': 9
    },
    {
      'name': '公路项目',
      'value': 9
    },
    {
      'name': '输变电项目',
      'value': 9
    },
    {
      'name': '生物质',
      'value': 8
    },
    {
      'name': '中国路桥',
      'value': 8
    },
    {
      'name': '物质电厂',
      'value': 8
    },
    {
      'name': '水电八局',
      'value': 7
    },
    {
      'name': '雨水排水',
      'value': 6
    },
    {
      'name': '西港输变电',
      'value': 6
    },
    {
      'name': '微网',
      'value': 6
    },
    {
      'name': '中尼',
      'value': 6
    },
    {
      'name': '进厂道路',
      'value': 6
    },
    {
      'name': '风电机组',
      'value': 5
    },
    {
      'name': '印尼芝',
      'value': 5
    },
    {
      'name': '法国公司',
      'value': 5
    },
    {
      'name': '中国铁建',
      'value': 5
    },
    {
      'name': '金风科技',
      'value': 5
    },
    {
      'name': '水电站项目',
      'value': 5
    },
    {
      'name': '机械工程公司',
      'value': 5
    },
    {
      'name': '捞越州',
      'value': 5
    },
    {
      'name': '网项目',
      'value': 5
    },
    {
      'name': '葛洲坝集团',
      'value': 5
    },
    {
      'name': '扎电厂',
      'value': 5
    }
  ]
}
